function transitionEndedOnHeightHandler(content, callback) {
    if (!content.clientHeight) {
        content.style.overflow = 'hidden';
        if (callback) {
            callback();
        }
    } else {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
    }
}

function handleHeightForAnimation(content, initialOverflow) {
    content.style.height = `${content.scrollHeight}px`;
    if (!content.clientHeight) {
        setTimeout(() => {
            content.style.overflow = initialOverflow ? 'initial' : 'hidden';
            content.style.height = `${content.scrollHeight}px`;
        }, 0);
    } else {
        content.style.overflow = 'hidden';
        content.style.height = '0px';
    }
}

function simulateResizeEvent() {
    const resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    Promise.resolve().then(() => window.dispatchEvent(resizeEvent));
}

export default {
    handleHeightForAnimation,
    transitionEndedOnHeightHandler,
    simulateResizeEvent,
};
